<script lang="ts">
	import HugeHeading from "@components/HugeHeading.svelte";
	import ProductCard from "@components/ProductCard.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Link from "@components/common/Link.svelte";
	import type { ClassValue } from "svelte/elements";
	import { MediaQuery } from "svelte/reactivity";
	import { ButtonVariant } from "../../../../core/schema/ButtonVariant.js";
	import type { Product } from "@core/schema/Product.js";
	import { getProductsCataloguePath } from "@core/schema/paths/getProductsCataloguePath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const { products, class: customClass }: { products: Product[]; class?: ClassValue } = $props();
	const { tenant } = getGlobalTemplateProps();
	const xlUp = new MediaQuery("(min-width: 1280px)", false);
</script>

<section
	class={[
		customClass,
		"full-width overflow-hidden max-w-[120rem] mx-auto py-8 md:py-16 lg:py-20 [&:is(&)]:px-[var(--container-gap)]",
	]}
>
	<div class="flex flex-col min-[1920px]:flex-row gap-x-16">
		<div class="flex justify-start items-center max-w-[33.25rem] w-full order-2 min-[1920px]:order-1">
			<p
				class="mt-4 lg:mt-6 mb-8 lg:mb-12 min-[1920px]:my-0 md:text-[1.25rem]/[1.4] text-xs/[1.4] font-semibold text-left"
			>
				<Formatted
					text="Zatímco konkurence zaspává dobu, vy využijete moderní produkty k úspoře nákladů a zrychlení procesů."
				/>
			</p>
		</div>

		<div class="w-full order-1 min-[1920px]:order-2">
			<HugeHeading
				level={2}
				class="text-left min-[1920px]:text-right max-[1920px]:translate-y-0 w-fit"
				text="stroke[[Tato řešení]] nl[[]] mění pravidla hry nl[[]]v logistice"
			/>
		</div>
	</div>

	<div class="min-[1920px]:max-w-[120.5rem] min-[1920px]:mx-auto">
		<div
			class="grid gap-1 md:gap-2 md:justify-center grid-cols-2 lg:grid-cols-3 min-[1920px]:[grid-template-columns:repeat(6,minmax(18.875rem,18.875rem))]"
		>
			{#each products.slice(0, xlUp.current ? 12 : 6) as product (product.id)}
				<ProductCard {product} class="min-h-[19.125rem] md:min-h-[24.75rem]" />
			{/each}
		</div>
	</div>

	<div class="flex w-full justify-center mt-6 md:mt-16">
		<Link href={getProductsCataloguePath(tenant.locale)} variant={ButtonVariant.Outlined} icon="arrow">
			<Formatted text="Všechny produkty" />
		</Link>
	</div>
</section>
